module.exports = __webpack_public_path__ + "img/gradientshadow.3f41daf5.svg";